import React, { useEffect, useState } from 'react';
import {
  Box, Container, Typography, Button, Grid, Card, CardContent, Stack, CircularProgress
} from '@mui/material';
import { Link } from 'react-router-dom';
import PhoneIcon from '@mui/icons-material/Phone';
import MessageIcon from '@mui/icons-material/Message';
import axiosInstance from '../../api/axiosConfig';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
const Home = () => {
  const [courses, setCourses] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(true);

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      const res = await axiosInstance.get('/courses');
      const data = res.data.data || res.data;
      setCourses(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Failed to load courses', err);
      setCourses([]);
    } finally {
      setLoadingCourses(false);
    }
  };

  return (
    <>
      {/* HERO */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
          color: 'white',
          py: { xs: 8, md: 12 },
          textAlign: 'center'
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="h2" sx={{ fontWeight: 700, fontSize: { xs: '2rem', md: '3rem' } }}>
            Kavya Institute Of Fire & Industrial Safety
          </Typography>

          <Typography variant="h6" sx={{ mt: 2, mb: 3, opacity: 0.9 }}>
            Quality Education & Professional Development
          </Typography>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center" mb={3}>
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
              <PhoneIcon />
              <Typography variant="body2">+91-7979-966901</Typography>
            </Stack>
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
              <MessageIcon />
              <Typography variant="body2">kifisrg@gmail.com</Typography>
            </Stack>
          </Stack>

          <Box
  sx={{
    mb: 3,
    p: 2,
    borderRadius: 2,
    backgroundColor: 'rgba(255,255,255,0.15)',
    display: 'inline-block'
  }}
>
  <Typography variant="body2" sx={{ fontWeight: 600 }}>
    ✓ ISO 9001:2015 Certified | ✓ Govt. of India Registered
  </Typography>

  <Typography variant="body2" sx={{ mt: 0.5 }}>
    CIN: U85499DC2026PTC471131
  </Typography>

  <Typography variant="body2">
    UDYAM-BR-35-0003536
  </Typography>

  <Typography variant="caption" sx={{ opacity: 0.9 }}>
    A Unit of KAVYARG GLOBAL INDIA PRIVATE LIMITED
  </Typography>
</Box>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
            <Button variant="contained" size="large" sx={{ bgcolor: '#fff', color: '#1976d2', fontWeight: 700 }} component={Link} to="/courses">
              Explore Courses
            </Button>
            <Button variant="outlined" size="large" sx={{ color: '#fff', borderColor: '#fff' }} href="tel:+919876543210">
              Call Us Now
            </Button>
          </Stack>
        </Container>
      </Box>

      {/* ABOUT */}
      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 10 } }}>
        <Typography variant="h4" textAlign="center" fontWeight={700} mb={4}>
          About Kavya Institute
        </Typography>

        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Typography paragraph>
              Kavya Institute is a leading educational institution dedicated to providing high-quality academic
              and professional development courses.
            </Typography>
            <Typography paragraph>
              Our faculty comprises industry experts and experienced educators committed to student success.
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card sx={{ bgcolor: '#f9f9f9', borderRadius: 3 }}>
              <CardContent>
                <Typography fontWeight={700} mb={2}>Why Choose Us?</Typography>
                <Typography variant="body2">
                  ✓ Expert faculty<br />
                  ✓ Industry-aligned curriculum<br />
                  ✓ Hands-on training<br />
                  ✓ Certification<br />
                  ✓ Placement assistance
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>

      {/* COURSES FROM API */}
      <Box sx={{ bgcolor: '#f5f7fa', py: { xs: 6, md: 10 } }}>
        <Container maxWidth="lg">
          <Typography variant="h4" textAlign="center" fontWeight={700} mb={6}>
            Our Courses
          </Typography>

          {loadingCourses ? (
            <Box textAlign="center">
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={4}>
              {courses.slice(0, 4).map(course => (
                <Grid item xs={12} sm={6} md={3} key={course.courseId}>
                  <Card sx={{ height: '100%', borderRadius: 3, transition: '0.3s', '&:hover': { transform: 'translateY(-6px)' } }}>
                    <CardContent>
                      <Typography fontWeight={700} gutterBottom>
                        {course.courseName}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Professional certification program
                      </Typography>
                      <Typography variant="caption" color="primary" sx={{ fontWeight: 600 }}>
                        Duration: {course.durationMonths} Months
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}

          <Box textAlign="center" mt={5}>
            <Button variant="contained" size="large" component={Link} to="/courses">
              View All Courses
            </Button>
          </Box>
        </Container>
      </Box>

      <Box sx={{ bgcolor: '#f5f7fa', py: { xs: 6, md: 10 } }}>
  <Container maxWidth="lg">
    <Typography variant="h4" fontWeight={700} textAlign="center" mb={6}>
      Career Opportunities After Certification
    </Typography>

    <Grid container spacing={4}>
      {[
        "Safety Officer in Factories",
        "Fire Safety Supervisor",
        "Construction Safety Inspector",
        "Industrial Safety Executive",
        "EHS (Environment Health Safety) Officer",
        "Oil & Gas Safety Coordinator"
      ].map((career, i) => (
        <Grid item xs={12} sm={6} md={4} key={i}>
          <Card sx={{ borderRadius: 3 }}>
            <CardContent>
              <Typography fontWeight={600}>✓ {career}</Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  </Container>
</Box>


      <Box sx={{ py: { xs: 6, md: 10 } }}>
  <Container maxWidth="lg">
    <Typography variant="h4" fontWeight={700} textAlign="center" mb={6}>
      Our Practical Training Facilities
    </Typography>

    <Grid container spacing={4}>
      {[
        {
          title: "Fire Fighting Equipment Training",
          desc: "Students receive hands-on training with fire extinguishers, hydrants, and emergency response equipment."
        },
        {
          title: "Industrial Safety Lab",
          desc: "Practical demonstrations on hazard identification, PPE usage, and industrial risk management."
        },
        {
          title: "Construction Safety Demonstration",
          desc: "Training on scaffolding safety, height safety, and on-site hazard prevention."
        },
        {
          title: "Emergency Drill Practice",
          desc: "Mock emergency evacuations and real-life fire and disaster response training."
        }
      ].map((item, i) => (
        <Grid item xs={12} sm={6} md={3} key={i}>
          <Card sx={{ height: '100%', borderRadius: 3 }}>
            <CardContent>
              <Typography fontWeight={700} gutterBottom>{item.title}</Typography>
              <Typography variant="body2" color="text.secondary">{item.desc}</Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  </Container>
</Box>

<Box sx={{ bgcolor: '#e3f2fd', py: { xs: 6, md: 10 } }}>
  <Container maxWidth="lg">
    <Typography variant="h4" fontWeight={700} textAlign="center" mb={6}>
      Placement Assistance & Industry Support
    </Typography>

    <Grid container spacing={4}>
      {[
        "Resume preparation support",
        "Mock interview training",
        "Industry job referrals",
        "Guidance for Gulf country safety jobs",
        "Internship opportunities",
        "Lifetime career guidance"
      ].map((item, i) => (
        <Grid item xs={12} sm={6} md={4} key={i}>
          <Card sx={{ borderRadius: 3 }}>
            <CardContent>
              <Typography fontWeight={600}>✓ {item}</Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  </Container>
</Box>

<Container maxWidth="lg" sx={{ py: { xs: 6, md: 10 } }}>
  <Typography variant="h4" fontWeight={700} textAlign="center" mb={4}>
    Why Safety Education Matters
  </Typography>

  <Typography textAlign="center" maxWidth="900px" mx="auto" color="text.secondary">
    Industrial and fire safety professionals play a critical role in preventing workplace accidents,
    protecting lives, and ensuring legal compliance in industries, construction sites, oil & gas plants,
    and commercial buildings. Proper safety training reduces risks, prevents injuries, and saves lives.
    Kavya Institute prepares students to become responsible and skilled safety professionals.
  </Typography>
</Container>


<Box sx={{ py: { xs: 6, md: 10 } }}>
  <Container maxWidth="lg">
    <Typography variant="h4" fontWeight={700} textAlign="center" mb={6}>
      Our Impact in Numbers
    </Typography>

    <Grid container spacing={4} textAlign="center">
      {[
        { number: "5000+", label: "Students Trained" },
        { number: "120+", label: "Industry Tie-ups" },
        { number: "95%", label: "Placement Support Rate" },
        { number: "10+", label: "Years of Excellence" }
      ].map((item, i) => (
        <Grid item xs={6} md={3} key={i}>
          <Typography variant="h3" fontWeight={700} color="primary">{item.number}</Typography>
          <Typography variant="body2" color="text.secondary">{item.label}</Typography>
        </Grid>
      ))}
    </Grid>
  </Container>
</Box>


<Box sx={{ bgcolor: '#f9fafc', py: { xs: 6, md: 10 } }}>
  <Container maxWidth="md">
    <Typography variant="h4" fontWeight={700} textAlign="center" mb={6}>
      Frequently Asked Questions
    </Typography>

    {[
      {
        q: "Who can enroll in Fire & Industrial Safety courses?",
        a: "Anyone who has completed 10th, 12th, ITI, Diploma, or Graduation can enroll. These courses are suitable for freshers as well as working professionals who want to build a career in safety management."
      },
      {
        q: "Is this course helpful for jobs in Gulf countries?",
        a: "Yes. Our Fire & Industrial Safety courses are highly demanded in Gulf countries like UAE, Saudi Arabia, Qatar, and Oman. Many of our students are working abroad as Safety Officers and Fire Supervisors."
      },
      {
        q: "Do you provide practical training?",
        a: "Absolutely. We provide hands-on practical training including fire extinguisher usage, industrial hazard identification, PPE training, emergency response drills, and safety inspection procedures."
      },
      {
        q: "Will I get a certificate after course completion?",
        a: "Yes. Students receive an industry-recognized certification from Kavya Institute after successfully completing the course and passing the assessments."
      },
      {
        q: "Do you provide placement assistance?",
        a: "Yes. We provide resume building support, interview preparation, and job referrals. We also guide students for Gulf job opportunities and safety officer positions in industries."
      },
      {
        q: "What is the duration of the courses?",
        a: "Course durations range from 3 months to 1 year depending on the program. Diploma and Advanced Diploma programs typically range between 6 to 12 months."
      },
      {
        q: "Are classes available online?",
        a: "Yes. We offer both classroom training and online learning options for students who cannot attend in person."
      },
      {
        q: "What salary can I expect after completing the course?",
        a: "Freshers in India can expect ₹15,000–₹30,000 per month. Gulf jobs may offer ₹80,000+ per month depending on experience and job role."
      }
    ].map((faq, i) => (
      <Accordion key={i} sx={{ mb: 2, borderRadius: 2, '&:before': { display: 'none' } }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography fontWeight={600}>{faq.q}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body2" color="text.secondary">
            {faq.a}
          </Typography>
        </AccordionDetails>
      </Accordion>
    ))}
  </Container>
</Box>

      {/* CTA */}
      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 10 } }}>
        <Card sx={{ borderRadius: 3, p: { xs: 3, md: 5 }, textAlign: 'center', background: 'linear-gradient(135deg,#1976d2,#1565c0)', color: '#fff' }}>
          <Typography variant="h5" fontWeight={700} mb={2}>
            Ready to Start Your Learning Journey?
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
            <Button variant="contained" sx={{ bgcolor: '#fff', color: '#1976d2', fontWeight: 700 }}>
              Enroll Now
            </Button>
            <Button variant="outlined" sx={{ color: '#fff', borderColor: '#fff' }}>
              Chat on WhatsApp
            </Button>
          </Stack>
        </Card>
      </Container>
    </>
  );
};

export default Home;
